const initialState = {
    shops: [],
};
const shops = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_PAGE_SHOPS':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default shops;
